module.exports = __webpack_public_path__ + "static/media/BFSI-FE-championship-Fintech-Summit-2023.643f1317.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BFSI-FE-championship-Fintech-Summit-2023.webp
// module id = 131
// module chunks = 0